// extracted by mini-css-extract-plugin
export default {"wrapper":"Radio_wrapper__EzFT6","radio":"Radio_radio__cJbNV"};